module.exports = "../../app/cells/components/modals/setup_wizard_cell.rb";